import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { RolesScreen } from './pages/RolesScreen';

export const rolesRoutes = (
  <Route
    path="/user-roles"
    element={
      <ProtectedRoute>
        <OnboardingCompletionGuard>
          <RolesScreen />
        </OnboardingCompletionGuard>
      </ProtectedRoute>
    }
  />
);
